<div class="justify-center px-[60px] py-[30px] ">
  <h5 class="text-[16px] leading-[26px] font-semibold">Your Multiplier</h5>
  <p class="font-normal text-[12px] leading-[20px] text-[#636363]">
    Anytime a reward is showing, your multiplier will have already been applied. 
    Total points earned will be tracked in your Points Activity. 
    Each member may earn a different amount of points for each post, depending on their multiplier. 
    For example, someone with a 1.1x multiplier would receive 11 points whereas someone with a 2.0x multiplier would receive 20 points for opening the same post.
  </p>
</div>  